import { TextInput, TextInputProps } from '@mantine/core'
import { acceptOnlyNumbers, acceptOnlyNumbersWithDecimal } from '../../../../utils/validators';

interface ETextInputProps extends TextInputProps {
  allowOnlyNumbers?: boolean;
  allowOnlyNumbersWithDecimal?: boolean;
}


export function ETextInput(props: ETextInputProps) {
  return (
    <TextInput
      {...props}
      styles={{
        input: {
          borderRadius: '8px',
          fontSize: '17px',
        },
        label: {
          marginBottom: '2px',
          fontWeight: 400,
          fontSize: '15px',
          color: '#374151',
        },
        error: {
          fontSize: '12px',
          marginTop: '4px',
        },

        ...props.styles as any,
      }}
      onChange={(e) => {
        if (props.allowOnlyNumbers || props.allowOnlyNumbersWithDecimal) {
          e.target.value = props.allowOnlyNumbersWithDecimal ? acceptOnlyNumbersWithDecimal(e.target.value) : acceptOnlyNumbers(e.target.value);
        }
        props.onChange?.(e);
      }}
      value={props.value?.toString().replaceAll("undefined", "")}
      maxLength={props.maxLength ? props.maxLength : 100}
    />
  )
}
